const MS_PER_HOUR = 3_600_000;
const MIN_INTERVAL_MS = 1_000;
const MAX_INTERVAL_MS = 30_000;

export function resolveTimeCounterIntervalMs(decimals: number): number {
  const msPerDisplayedStep = MS_PER_HOUR / 10 ** decimals;

  return Math.min(MAX_INTERVAL_MS, Math.max(MIN_INTERVAL_MS, msPerDisplayedStep / 2));
}
